import produce, { Draft } from 'immer';

import {
    APPLY_REGIONS_TRANSFORM_EDITOR,
    CANCEL_REGIONS_TRANSFORM_EDITOR,
    CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR,
    CLOSE_REGIONS_TRANSFORM_EDITOR,
    END_APPLY_REGIONS_TRANSFORM_EDITOR,
    FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR,
    OPEN_REGIONS_TRANSFORM_EDITOR,
    RegionsTransformEditorAction,
    UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR,
    UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR
} from '../actions/regionsTransformEditor';
import { getDefaultRegionsTransformEditorState } from '../service/RegionsTransformEditorHelper/RegionsTransformEditorHelper';
import { GdUpdateAdGroupRegionsActionInput } from '../typings/graphql-grid';
import { RegionsTransformEditorsState } from '../typings/regionsTransformEditor';
import { State } from '../typings/state';

export function regionsTransformEditor(
    state: RegionsTransformEditorsState = {},
    action: RegionsTransformEditorAction,
    fullState: State
): RegionsTransformEditorsState {
    return produce(state, (draftState: Draft<RegionsTransformEditorsState>) => {
        switch (action.type) {
            case OPEN_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId] = {
                    ...getDefaultRegionsTransformEditorState(),
                    isOpened: true,
                    typeSelectedRegionsTransform: GdUpdateAdGroupRegionsActionInput.REPLACE,
                    campaignsIds: action.campaignsIds,
                    groupsIds: action.groupsIds,
                    errors: undefined
                };
                break;
            }
            case CLOSE_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].isOpened = false;
                draftState[action.editorId].isLoading = false;
                draftState[action.editorId].errors = undefined;
                break;
            }
            case CANCEL_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].isOpened = false;
                draftState[action.editorId].isLoading = false;
                draftState[action.editorId].errors = undefined;
                break;
            }
            case CHANGE_TYPE_TRANSFORM_FOR_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].typeSelectedRegionsTransform = action.typeTransform;
                draftState[action.editorId].errors = undefined;
                break;
            }
            case UPDATE_QUICK_SELECTED_ITEMS_FOR_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].quickSelectedItems = action.quickSelectedItems;
                draftState[action.editorId].isQuickSelectItemsLoading = action.isQuickSelectItemsLoading;
                break;
            }
            case APPLY_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].isLoading = true;
                draftState[action.editorId].errors = undefined;
                break;
            }
            case END_APPLY_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].isLoading = false;
                break;
            }
            case FETCH_TOP_REGIONS_FOR_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].isQuickSelectItemsLoading = true;
                break;
            }
            case UPDATE_VALIDATION_ERRORS_FOR_REGIONS_TRANSFORM_EDITOR: {
                draftState[action.editorId].errors = action.errors;
                break;
            }
            default:
                break;
        }

        return draftState;
    });
}
